// File: authService.js

import { 
  getAuth, 
  signInWithEmailAndPassword, 
  createUserWithEmailAndPassword, 
  signInWithPopup, 
  GoogleAuthProvider,
  signOut 
} from "firebase/auth";
import { initializeApp } from "firebase/app";

// (You can also import your existing firebaseConfig from its file, 
//  but this example shows a self‐contained setup—just remove this block 
//  if you already have firebaseConfig.js exporting `app`.)

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDsGiWhixpIjx3_Yw4HXIZO74ifIjAR-Ek",
  authDomain: "ss-auth-c6f84.firebaseapp.com",
  projectId: "ss-auth-c6f84",
  storageBucket: "ss-auth-c6f84.firebasestorage.app",
  messagingSenderId: "70118011581",
  appId: "1:70118011581:web:cd74d408e4bd21189b3dd4",
  measurementId: "G-6X8HVG4MWZ"
};

// Initialize Firebase (only do this once in your whole app; if you already
// have a separate firebaseConfig.js that does initializeApp, you can delete
// this block and instead import { auth } from your firebaseConfig.js)
const app = initializeApp(firebaseConfig);

// Create and export the `auth` instance for use in your project:
const auth = getAuth(app);

// ---------- Auth Service Functions ----------

/**
 * Sign in an existing user with email & password.
 * @param {string} email 
 * @param {string} password 
 * @returns {Promise<UserCredential>}
 */
export const login = (email, password) => {
  return signInWithEmailAndPassword(auth, email, password);
};

/**
 * Create a new user account with email & password.
 * @param {string} email 
 * @param {string} password 
 * @returns {Promise<UserCredential>}
 */
export const register = (email, password) => {
  return createUserWithEmailAndPassword(auth, email, password);
};

/**
 * Trigger Google sign‐in popup.
 * @returns {Promise<UserCredential>}
 */
export const googleLogin = () => {
  const provider = new GoogleAuthProvider();
  return signInWithPopup(auth, provider);
};

/**
 * Sign out the currently logged‐in user.
 * @returns {Promise<void>}
 */
export const logout = () => {
  return signOut(auth);
};

/**
 * Get the current Firebase user (if signed in), or null otherwise.
 * You can call this in a React effect or anywhere you need to check auth state.
 * @returns {import("firebase/auth").User | null}
 */
export const getCurrentUser = () => {
  return auth.currentUser;
};
